import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
import App from './App.vue'
import router from './router'
import client from './client/client'
import './assets/tailwind.css'

Vue.config.productionTip = false

Vue.use(VueAnalytics, {
  id: client.gaTrackingId,
  router,
  debug: {
    // defaults: false, false, true
    enabled: false,
    trace: false,
    sendHitTask: true
  }
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
